import store from '../store';

class TradovatePlatform {

    constructor() {
        this.user = store.state.user;
    }

    fromExcelToTrades(rawTrades, brokerToLink) {
        // eslint-disable-next-line no-console
        console.log(rawTrades);
        let trades = [];
        //let excelTrades = [];
        //let finish = false;
        //let canAdd = false;

        //excelTrades.shift();
        rawTrades.forEach((trade) => {
            let grossProfit = Number(this.removeCurrency(this.matchIndexes(trade, 'grossProfit')));
            let partialOpenPrice = Number(this.removeCurrency(this.matchIndexes(trade, 'openPrice')));
            let partialClosePrice = Number(this.removeCurrency(this.matchIndexes(trade, 'closePrice')));
            let partialOpenTime = this.convertDate(this.matchIndexes(trade, 'openTime'));
            let partialCloseTime = this.convertDate(this.matchIndexes(trade, 'closeTime'));
            let side = (grossProfit > 0 && partialOpenPrice < partialClosePrice)? 'BUY' : 'SELL';

            // eslint-disable-next-line no-console
            //console.log(`${grossProfit} - ${side} - ${partialOpenTime} - ${partialOpenPrice}`);

            try {
                let tradeToAdd = {
                    user: {id: this.user.id, login: this.user.username},
                    brokerAccount: {identifier: this.matchIndexes(trade, 'account'), broker: {id: brokerToLink},},
                    assetTicker: this.matchIndexes(trade, 'asset'),
                    side: side,
                    openTime: (side === 'BUY')? partialOpenTime : partialCloseTime,
                    closeTime: (side === 'BUY')? partialCloseTime : partialOpenTime,
                    openPrice: (side === 'BUY')? partialOpenPrice : partialClosePrice,
                    closePrice: (side === 'BUY')? partialClosePrice : partialOpenPrice,
                    netProfit: grossProfit,
                    commissions: 0,
                    pipValue: 0,
                    stopLossPrice: 0,
                    contracts: Number(this.removeCurrency(this.matchIndexes(trade, 'contracts'))),
                };

                let priceDistance = Math.abs(tradeToAdd.openPrice - tradeToAdd.closePrice);
                tradeToAdd.pipValue = (priceDistance > 0.0) ? (Math.abs(tradeToAdd.netProfit) / (priceDistance)).toFixed(2) : 0;
                tradeToAdd.netProfit = tradeToAdd.netProfit - Math.abs(tradeToAdd.commissions);
                if (tradeToAdd.stopLossPrice === 0)
                    tradeToAdd.stopLossPrice = (tradeToAdd.side === 'BUY') ? tradeToAdd.openPrice - priceDistance : tradeToAdd.openPrice + priceDistance;
                trades.push(tradeToAdd);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.log("There's an error");
            }
        });

        return trades;
    }

    matchIndexes(trade, itemType) {
        switch (itemType) {
            case 'sequence':
                return trade[0];
            case 'account':
                return 'Tradovate';
            case 'asset':
                return trade[0].toUpperCase();
            case 'side':
                return (trade[2] === 'vender')? 'SELL' : (trade[2] === 'comprar')? 'BUY' : trade[2].toUpperCase();
            case 'openTime':
                return trade[10];
            case 'closeTime':
                return trade[11];
            case 'openPrice':
                return trade[7];
            case 'closePrice':
                return trade[8];
            case 'stopLossPrice':
                return (trade[6] !== undefined && trade[6] != null)? trade[6] : 0;
            case 'grossProfit':
                return trade[9];
            case 'contracts':
                return trade[6];
        }
    }

    convertDate(stringDate) {
        let array = stringDate.split(' ');
        // Date related
        let date = array[0].split('/');
        let year = `20${date[2]}`;
        let month = date[0];
        let day = date[1];

        // Time related
        let time = array[1].split(':');
        let hour = time[0];
        let minute = time[1];
        return new Date(year, month - 1, day, hour, minute);
    }
    removeCurrency(string) {
        let newString = string.toString().trim();
        let currencies = ['$', '€', '£', '¥', '₽', '₺', 'CHF', 'R', 'S', '₩', '₫', ' '];
        currencies.forEach((currency) => { newString = newString.replace(currency, '') });
        newString = newString.replace(',', '.');
        if(newString.includes('('))
            newString = `-${newString.replace('(', '').replace(')', '')}`;
        return newString;
    }
}

export default new TradovatePlatform();
